import {
    ExperimentNames as Exps,
    TestExperiment01Variants,
} from "./experiments";
import { ExperimentState } from "./types";

// // // //

/**
 * DEFAULT_EXPERIMENT_STATE
 * Default value for `User.experiments`. Every running experiment maps to ""
 * (the "not enrolled" sentinel) until PostHog assigns a variant.
 *
 * This object also acts as a compile-time guard: if a new experiment is added
 * to ExperimentNames without a matching entry here, TS will fail.
 */
export const DEFAULT_EXPERIMENT_STATE: ExperimentState = {
    [Exps.testExperiment01]: TestExperiment01Variants.control,
    // [Exps.inlinePopupAuthExtended]: InlinePopupAuthExtendedVariants.control,
    // [Exps.globalPaywallExperiment01]: GlobalPaywallExperiment01Variants.control,
    // [Exps.freeTrialsExperiment]: FreeTrialsExperimentVariants.control,
};
